import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { ColumnLayout } from "../components/Layout/ColumnLayout";
import { ContentLayout } from "../components/Layout/ContentLayout";
import { SupportInfo } from "../components/Support/SupportInfo";
import { SystemInformation } from "../components/Support/SystemInformation";
import { Page } from "./Page";

export const SupportPage = () => {
    return (
        <Page title="Support">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Support Info</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>
                <ColumnLayout.Fill>
                    <ContentLayout isWide className="space-y-8">
                        <SupportInfo />
                        <SystemInformation />
                    </ContentLayout>
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
